// extracted by mini-css-extract-plugin
export default {"main_page":"RenaultDaster_main_page__OV0En","car_image":"RenaultDaster_car_image__R4yFz"};